// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* One employee's shift calendar (react-big-calendar), scoped under .emp-shifts */

.emp-shifts .emp-shifts__calendar {
  margin-top: var(--ds-space-2);
  padding: var(--ds-space-2);
  background: var(--ds-surface);
  border-radius: var(--ds-radius-lg);
}

.emp-shifts .rbc-toolbar {
  gap: var(--ds-space-2);
}

.emp-shifts .rbc-event,
.emp-shifts .rbc-agenda-event-cell {
  overflow-wrap: anywhere;
}

.emp-shifts .emp-shifts__swap {
  margin-top: var(--ds-space-2);
  min-height: 40px;
}

@media (max-width: 767.98px) {
  .emp-shifts .emp-shifts__calendar {
    padding: var(--ds-space-1);
  }

  .emp-shifts .rbc-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .emp-shifts .rbc-toolbar .rbc-toolbar-label {
    order: -1;
    padding: 0;
    font-weight: 600;
    text-align: center;
  }

  .emp-shifts .rbc-toolbar .rbc-btn-group {
    display: flex;
  }

  .emp-shifts .rbc-toolbar .rbc-btn-group > button {
    flex: 1 1 0;
    padding-inline: var(--ds-space-1);
  }

  /* Week and month grids keep their columns and scroll sideways inside the frame */
  .emp-shifts .rbc-time-view,
  .emp-shifts .rbc-month-view {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .emp-shifts .is-week .rbc-time-header,
  .emp-shifts .is-week .rbc-time-content {
    min-width: 640px;
  }

  .emp-shifts .rbc-month-view .rbc-month-header,
  .emp-shifts .rbc-month-view .rbc-month-row {
    min-width: 560px;
  }

  /* Agenda: date, time and shift stack readably in narrow columns */
  .emp-shifts .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
    padding: var(--ds-space-2);
    vertical-align: top;
  }

  .emp-shifts .rbc-agenda-view .rbc-agenda-time-cell {
    white-space: nowrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/commons/Employees/EmpShifts/EmpShifts.css"],"names":[],"mappings":"AAAA,iFAAiF;;AAEjF;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,iCAAiC;EACnC;;EAEA,iFAAiF;EACjF;;IAEE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA,kEAAkE;EAClE;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* One employee's shift calendar (react-big-calendar), scoped under .emp-shifts */\n\n.emp-shifts .emp-shifts__calendar {\n  margin-top: var(--ds-space-2);\n  padding: var(--ds-space-2);\n  background: var(--ds-surface);\n  border-radius: var(--ds-radius-lg);\n}\n\n.emp-shifts .rbc-toolbar {\n  gap: var(--ds-space-2);\n}\n\n.emp-shifts .rbc-event,\n.emp-shifts .rbc-agenda-event-cell {\n  overflow-wrap: anywhere;\n}\n\n.emp-shifts .emp-shifts__swap {\n  margin-top: var(--ds-space-2);\n  min-height: 40px;\n}\n\n@media (max-width: 767.98px) {\n  .emp-shifts .emp-shifts__calendar {\n    padding: var(--ds-space-1);\n  }\n\n  .emp-shifts .rbc-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .emp-shifts .rbc-toolbar .rbc-toolbar-label {\n    order: -1;\n    padding: 0;\n    font-weight: 600;\n    text-align: center;\n  }\n\n  .emp-shifts .rbc-toolbar .rbc-btn-group {\n    display: flex;\n  }\n\n  .emp-shifts .rbc-toolbar .rbc-btn-group > button {\n    flex: 1 1 0;\n    padding-inline: var(--ds-space-1);\n  }\n\n  /* Week and month grids keep their columns and scroll sideways inside the frame */\n  .emp-shifts .rbc-time-view,\n  .emp-shifts .rbc-month-view {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .emp-shifts .is-week .rbc-time-header,\n  .emp-shifts .is-week .rbc-time-content {\n    min-width: 640px;\n  }\n\n  .emp-shifts .rbc-month-view .rbc-month-header,\n  .emp-shifts .rbc-month-view .rbc-month-row {\n    min-width: 560px;\n  }\n\n  /* Agenda: date, time and shift stack readably in narrow columns */\n  .emp-shifts .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n    padding: var(--ds-space-2);\n    vertical-align: top;\n  }\n\n  .emp-shifts .rbc-agenda-view .rbc-agenda-time-cell {\n    white-space: nowrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
